import React from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  return <SalesPage data-id="element-0" data-mp="35cby6hh7m18u" />;
}